export const types = {
    login: 'AUTH saveUser',
    logout: 'AUTH deleteUser',
    taskshow: 'TASK show',
    taskhide: 'TASK hide',

}